import { useEffect } from "react";

export default function NotFound() {
  useEffect(() => {
    // Ajouter meta tag pour SEO
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div className="tw-min-h-screen tw-bg-gray-50 tw-flex tw-items-center tw-justify-center tw-p-4">
      <div className="tw-max-w-md tw-w-full tw-bg-white tw-rounded-lg tw-shadow-lg tw-p-8">
        <div className="tw-text-center">
          {/* Icône 404 */}
          <div className="tw-mx-auto tw-flex tw-items-center tw-justify-center tw-h-16 tw-w-16 tw-rounded-full tw-bg-blue-100 tw-mb-4">
            <svg
              className="tw-h-8 tw-w-8 tw-text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
              />
            </svg>
          </div>

          <h1 className="tw-text-6xl tw-font-bold tw-text-gray-900 tw-mb-2">
            404
          </h1>

          <h2 className="tw-text-2xl tw-font-semibold tw-text-gray-800 tw-mb-4">
            Page non trouvée
          </h2>

          <div className="tw-text-gray-600 tw-mb-6 tw-space-y-2">
            <p>La page que vous recherchez n'existe pas ou a été déplacée.</p>
            <p className="tw-text-sm">
              Si vous pensez qu'il s'agit d'une erreur, vous pouvez nous contacter.
            </p>
          </div>

          {/* Boutons d'action */}
          <div className="tw-space-y-3">
            <button
              onClick={() => window.location.href = '/'}
              className="tw-w-full tw-px-4 tw-py-2 tw-bg-blue-600 tw-text-white tw-font-medium tw-rounded-md hover:tw-bg-blue-700 tw-transition-colors"
            >
              Retour à l'accueil
            </button>

            <button
              onClick={() => window.history.back()}
              className="tw-w-full tw-px-4 tw-py-2 tw-bg-gray-200 tw-text-gray-700 tw-font-medium tw-rounded-md hover:tw-bg-gray-300 tw-transition-colors"
            >
              Retour à la page précédente
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
